import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@material-ui/lab';

import { TextField } from '@material-ui/core';

const CustomAutocomplete = ({
  'data-testid': dataTestId,
  error,
  helpText,
  labelText,
  onChange,
  required,
  ...props
}) => (
  <Autocomplete
    {...props}
    onChange={(_, newValue) => {
      onChange(newValue);
    }}
    renderInput={params => (
      <TextField
        {...params}
        inputProps={{
          ...params.inputProps,
          'data-testid': dataTestId,
        }}
        required={required}
        label={labelText}
        error={error}
        helperText={helpText}
      />
    )}
  />
);

CustomAutocomplete.propTypes = {
  'data-testid': PropTypes.string,
  error        : PropTypes.bool.isRequired,
  helpText     : PropTypes.string,
  labelText    : PropTypes.string,
  name         : PropTypes.string,
  onChange     : PropTypes.func.isRequired,
  required     : PropTypes.bool,
  value        : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CustomAutocomplete.defaultProps = {
  'data-testid': undefined,
  helpText     : undefined,
  labelText    : undefined,
  name         : undefined,
  required     : false,
  value        : null,
};
export default CustomAutocomplete;
